import PropTypes from 'prop-types';
import * as React from 'react';

import styles from './MarkerListFormatter.less';
import MarkerListFormatterItem from './MarkerListFormatterItem';
import baseListFormatterParams from 'src/js/lib/raw_rendering/base_list_formatter_params';

class MarkerListFormatter extends React.PureComponent {
  render() {
    const {ownValue} = baseListFormatterParams(this.props);
    return ownValue ? (
      <div className={styles.dlMarkerList}>
        {ownValue &&
          ownValue.data &&
          ownValue.data.map((marker, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <MarkerListFormatterItem key={idx} marker={marker} />
          ))}
      </div>
    ) : (
      ''
    );
  }
}

MarkerListFormatter.displayName = 'MarkerListFormatter';

/* eslint-disable react/no-unused-prop-types */
MarkerListFormatter.propTypes = {
  value: PropTypes.objectOf(PropTypes.any),
};

MarkerListFormatter.defaultProps = {
  value: undefined,
};

export default MarkerListFormatter;
